/**
 * AuditWindowSelector — pill/tab group for time window selection.
 * Today (default) · Week · Month · Quarter · Year
 *
 * LOCKED: A4 drilldown uses sub-route pattern (hash routing).
 * LOCKED: A7 prior period — Quarter → prior quarter, Year → YTD vs plan.
 */
import { type TimeWindow } from "./audit-mock-data";
import { tokens } from "@/components/operator/tokens";

const WINDOWS: { key: TimeWindow; label: string }[] = [
  { key: "today",   label: "Today" },
  { key: "week",    label: "Week" },
  { key: "month",   label: "Month" },
  { key: "quarter", label: "Quarter" },
  { key: "year",    label: "Year" },
];

interface Props {
  active: TimeWindow;
  onChange: (w: TimeWindow) => void;
}

export default function AuditWindowSelector({ active, onChange }: Props) {
  return (
    <div
      style={{
        display: "flex",
        gap: 4,
        background: tokens.color.surfaceMute,
        border: `1px solid ${tokens.color.border}`,
        borderRadius: 8,
        padding: 4,
        width: "fit-content",
      }}
    >
      {WINDOWS.map(({ key, label }) => {
        const isActive = key === active;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            style={{
              padding: "6px 16px",
              borderRadius: 6,
              border: "none",
              background: isActive ? tokens.color.navy : "transparent",
              color: isActive ? "#FFFFFF" : tokens.color.textMuted,
              fontSize: 13,
              fontWeight: isActive ? 600 : 400,
              fontFamily: tokens.font.body,
              cursor: "pointer",
              transition: "background 0.15s, color 0.15s",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              if (!isActive) (e.currentTarget as HTMLButtonElement).style.background = "rgba(15,23,42,0.06)";
            }}
            onMouseLeave={(e) => {
              if (!isActive) (e.currentTarget as HTMLButtonElement).style.background = "transparent";
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
